import { VerifyEmailState } from './verifyEmail.types'

const initialState: VerifyEmailState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
